import { Content } from '../../types';

export const cambodiaVisaContent: Content = {
  title: 'ויזה לקמבודיה - כל מה שצריך לדעת לקראת הנחיתה!',
  imageUrl: '/images/cambodia-old/cambodia-visa/cambodia-visa-wide.png',
  introduction:
    'מתכננים טיול לקמבודיה? מעולה! אבל רגע לפני שאורזים תרמיל - חשוב לדעת: בעלי דרכון ישראלי חייבים ויזה לכניסה לקמבודיה . החדשות הטובות - התהליך פשוט ומהיר! להלן פירוט אודות כלל האפשרויות להוצאת ויזה לקראת כניסה לקמבודיה ובכלל זה, טיפים חשובים מהשטח.',
  sections: [
    {
      title: 'האפשרויות להוצאת ויזה - כולל טיפים חשובים מהשטח:',
      type: 'text',
      content: 'להלן האפשרויות העומדות בפניכם להוצאת ויזה לקמבודיה:',
    },
    {
      title: 'אפשרות 1: הוצאת ויזה מראש (eVisa אונליין)',
      type: 'text',
      content:
        'אפשר להנפיק ויזה מראש באמצעות האתר הרשמי של רשות ההגירה הקמבודית:\nhttps://www.evisa.gov.kh\nעלות : 36 דולר\nתוקף : 90 יום מיום ההנפקה אך השהייה בפועל הינה עד 30 יום בלבד\nסוג ויזה : כניסה חד - פעמית בלבד (לא ניתן לצאת ולחזור)\nזמן טיפול : עד 3 ימי עסקים\nנקודות כניסה מאושרות ל-eVisa :\nשדות תעופה: פנום פן, סיאם ריפ, סיהנוקוויל\nמעברי גבול:\nמתאילנד: Cham Yeam, Poi Pet\nמווייטנאם: Bavet\nמלאוס: Tropaeng Kreal\nמסמכים נדרשים :\n-\tתמונת פספורט דיגיטלית\n-\tדרכון בתוקף ל-6 חודשים לפחות\n-\tכרטיס אשראי לתשלום',
    },
    {
      title: 'אפשרות 2: ויזה בהגעה (ויזה בהגעה)',
      type: 'text',
      content:
        'אפשרות הפשוטה, הנוחה והזולה - הכי מתאימה וללא צורך להתעסק מראש עם הנושא.\nעלות : 30 דולר (במזומן בלבד)\nתוקף : 30 יום\nסוג ויזה : חד - פעמית בלבד\nמיקום : שדות התעופה הגדולים או מעברי גבול עם תאילנד, וייטנאם ולאוס\nמה נדרש להביא?\n-\tתמונת פספורט מודפסת\n-\tדרכון בתוקף ל-6 חודשים\n-\t30 דולר במזומן\nחשוב להכיר : במעברים יבשתיים (במיוחד בגבול עם תאילנד - Poi Pet), יש נסיונות לגבות "עמלות נוספות" או לשלוח אתכם לסוכנות המקומית. אל תתפתו - הויזה מונפקת במקום וללא תוספת!',
    },
    {
      title: 'פטור מוויזה - למי זה רלוונטי?',
      type: 'text',
      content:
        'בעלי דרכונים ממדינות דרום - מזרח אסיה הבאות פטורים מהוצאת ויזה : מלזיה, תאילנד, וייטנאם, לאוס, אינדונזיה, סינגפור, מיאנמר, פיליפינים, ברוניי, סיישל ומלדיבים.',
    },
    {
      title: 'הארכת ויזה בתוך קמבודיה:',
      type: 'text',
      content:
        'רוצים להישאר עוד? אפשר!\nניתן להאריך את הויזה ב - 30 יום נוספים באחד ממשרדי ההגירה המרכזיים (כגון בפנום פן או סיאם ריפ).\nניתן לבצע הארכה גם דרך סוכנויות תיירים - בתוספת עמלה.',
    },
    {
      title: 'שאלות נפוצות:',
      type: 'list',
      content: [
        {
          subtitle: 'האם ילדים צריכים ויזה?',
          text: 'בהחלט כן - כל אדם, כולל ילדים, חייב להחזיק בויזה נפרדת.',
        },
        {
          subtitle: 'האם ניתן לצאת ולהיכנס בשנית עם אותה ויזה?',
          text: 'לא. הויזה הינה לכניסה חד-פעמית בלבד. אם הינכם מתכננים לצאת לוייטנאם/ תאילנד/ לאוס או כל מדינה אחרת ולחזור - תידרשו להנפיק ויזה חדשה.',
        },
        {
          subtitle: 'ומה בנוגע לויזה ארוכת טווח?',
          text: 'קיימות ויזות עסקים או ויזות מסוג E המתאימות לשהייה ממושכת (לפרט דיגיטל נומאדס), אך הן דורשות מסמכים נוספים ואינן חלק מהויזות התיירותיות הסטנדרטיות.',
        },
      ],
    },
    {
      title: 'השורה תחתונה:',
      type: 'text',
      content:
        'במידה והינכם מעוניינים בדרך הקלה והפשוטה ו/ או אינכם בטוחים מראש מתי תיכנסו או רוצים לשמור על גמישות - ויזה בהגעה היא הדרך הנוחה,המהירה והזולה לכניסה לקמבודיה.\nרוצים להיות רגועים מראש ולחסוך המתנה במעבר הגבול? לכו על ה-eVisa!\nכך או כך - ברוכים הבאים לאחת המדינות הכי מרתקות באסיה!',
    },
  ],
};
